import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { CalendarIcon } from "lucide-react";
import { Button } from "../../../../../components/ui/button";
import { Calendar } from "../../../../../components/ui/calendar";
import { Card, CardContent } from "../../../../../components/ui/card";
import { Label } from "../../../../../components/ui/label";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../../../../components/ui/popover";
import { cn } from "../../../../../lib/utils";

interface DateFilterSectionProps {
  selectedDate: Date;
  onDateChange: (date: Date | undefined) => void;
}

export function DateFilterSection({
  selectedDate,
  onDateChange,
}: DateFilterSectionProps) {
  return (
    <Card>
      <CardContent className="p-6">
        <div className="space-y-3">
          <Label htmlFor="date-picker" className="text-base font-semibold">
            Filtrar por Data
          </Label>
          <Popover>
            <PopoverTrigger asChild>
              <Button
                id="date-picker"
                variant="outline"
                className={cn(
                  "w-full max-w-sm justify-start text-left font-normal",
                  !selectedDate && "text-muted-foreground"
                )}
              >
                <CalendarIcon className="mr-2 h-4 w-4" />
                {selectedDate ? (
                  format(selectedDate, "PPP", { locale: ptBR })
                ) : (
                  <span>Select date</span>
                )}
              </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start">
              <Calendar
                mode="single"
                selected={selectedDate}
                onSelect={onDateChange}
                initialFocus
              />
            </PopoverContent>
          </Popover>
        </div>
      </CardContent>
    </Card>
  );
}
